import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
    userSelect: 'none'
  }
}));
